
// 1.

// import React, { useContext, useEffect, useState } from "react";
// import {
//   Box,
//   Grid,
//   Paper,
//   Typography,
//   Avatar,
// } from "@mui/material";



// import PersonIcon from "@mui/icons-material/Person";


// import DashboardInverterData from "./DashboardInverterData/DashboardInverterData";
// import PvParameter from "../../../pv_monitoring/pv_monitoring_tabs/pv_parameter/PvParameter";
// import Tab1Inverter1 from "../../../inverter1/tabs/tab1Inverter1/Tab1Inverter1";
// import MainSlider from "./MainSlider/MainSlider";
// import { AppThemeContext } from "../../../../../../context/AppThemeContext";
// import DashboardInverterTab4 from "./DashboardInverterData/DashboardInverterTab4";
// import { InstantPowerApi } from "../../../../../../api/Api";

// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";

// import { Bar } from "react-chartjs-2";
// import Tab4ContentChart1 from "./Tab4ContentChart/TabContentChart1";
// import BottomSlider from "./Tab4ContentChart/BottomSlider";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// // import MainSlider from "./MainSlider";


// const DashboardTab4 = () => {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const [time, setTime] = useState(new Date());
//   const [logData, setLogData] = useState([]);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setTime(new Date());
//     }, 1000);

//     return () => clearInterval(timer);
//   }, []);

//   const [credentials, setCredentials] = useState({
//     USER_ID: localStorage.getItem("LoginID"),
//     PLANT_code: localStorage.getItem("LCODE"),
//     pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",

//   });

//   const fetchLogData = async () => {
//     const res = await InstantPowerApi(credentials);
//     if (res?.KW_current && Array.isArray(res.KW_current)) {
//       setLogData(res.KW_current);
//     } else {
//       setLogData([]);
//     }
//   };


//   useEffect(() => {
//     // run on mount + when dependency changes
//     fetchLogData();

//   }, [credentials]);


//   const cardStyle = {
//     p: 2,
//     borderRadius: 3,
//     boxShadow: 3,
//     height: "100%",
//     background: "#fff",
//   };

//   // 2. card chart

//   const chartData = {
//     labels: ["Incomer", "Outgoing", "Spare"],
//     datasets: [
//       {
//         label: "Power (KW)",
//         data: [
//           logData[0]?.Incomer || 0,
//           logData[0]?.Outgoing || 0,
//           logData[0]?.Spare || 0,
//         ],
//         backgroundColor: [
//           "#1976d2",
//           "#2e7d32",
//           "#ed6c02",
//         ],
//         borderWidth: 1,
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       title: {
//         display: true,
//         text: "Instantaneous Power [KW]",
//       },
//     },
//   };

//   return (

//     <>
//      <Box p={2} bgcolor="#f5f5f5">

//       {/* ================= TOP SECTION ================= */}

//       <Grid container spacing={1}>

//         {/* POWER CARD */}
//         <Grid item xs={12} sm={6} md={3}>
//           <Paper sx={cardStyle}>
//             <Typography
//               fontWeight="bold"
//               textAlign="center"
//               mb={2}
//             >
//               Instantaneous Power [KW]
//             </Typography>

//             {logData.map((log, index) => (
//               <Typography
//                 variant="h5"
//                 color="orange"
//                 align="center"
//                 mt={4}
//                 fontWeight="bold"
//               >
//                 {log.Incomer} (Incomer)
//               </Typography>
//             ))}

//             {logData.map((log, index) => (
//               <Typography
//                 variant="h5"
//                 color="orange"
//                 align="center"
//                 mt={4}
//                 fontWeight="bold"
//               >
//                 {log.Outgoing} (Outgoing)
//               </Typography>
//             ))}

//             {logData.map((log, index) => (
//               <Typography
//                 variant="h5"
//                 color="orange"
//                 align="center"
//                 mt={4}
//                 fontWeight="bold"
//               >
//                 {log.Spare} (Spare)
//               </Typography>
//             ))}
//           </Paper>
//         </Grid>

//         {/* CHART CARD */}
//         <Grid item xs={12} sm={6} md={3}>
//           <Paper sx={cardStyle}>
//             {/* <Typography
//               fontWeight="bold"
//               textAlign="center"
//               mb={2}
//             >
//               Live Chart
//             </Typography> */}

//             <Box >
//               <Bar
//                 data={chartData}
//                 options={chartOptions}
//               />
//             </Box>
//           </Paper>
//         </Grid>

//         {/* USER DETAIL */}
//         <Grid item xs={12} sm={6} md={3}>
//           <Paper sx={cardStyle}>
//             <Box display="flex" gap={2}>
//               <Avatar sx={{ bgcolor: "#1976d2" }}>
//                 <PersonIcon />
//               </Avatar>

//               <Box>
//                 <Typography fontWeight="bold">
//                   User Detail
//                 </Typography>

//                 <Typography variant="body2">
//                   Name: GLOSTER NUVO LIMITED
//                 </Typography>

//                 <Typography variant="body2">
//                   City: HOWRAH
//                 </Typography>

//                 <Typography variant="body2">
//                   Total Incomers: 13
//                 </Typography>

//                 <Typography variant="body2">
//                   Total Energy Meter: 6
//                 </Typography>

//                 <Typography
//                   variant="body2"
//                   color="orange"
//                 >
//                   Commissioned: 29-Aug-2024
//                 </Typography>
//               </Box>
//             </Box>
//           </Paper>
//         </Grid>

//         {/* CLOCK */}
//         <Grid item xs={12} sm={6} md={3}>
//           <Paper sx={cardStyle}>
//             <Typography
//               variant="h4"
//               align="center"
//               fontWeight="bold"
//             >
//               {time.toLocaleTimeString()}
//             </Typography>

//             <Typography
//               align="center"
//               mt={1}
//               color="text.secondary"
//             >
//               {time.toDateString()}
//             </Typography>
//           </Paper>
//         </Grid>

//       </Grid>

//       {/* ================= MIDDLE SECTION ================= */}

//       <Grid container spacing={1} mt={0.5}>

//         {[
//           { title: "Incomer", stype: "I" },
//           { title: "Outgoing", stype: "O" },
//           { title: "Spare", stype: "S" },
//           { title: "Sensor", stype: "W" },
//         ].map((item, i) => (
//           <Grid item xs={12} sm={6} md={3} key={i}>
//             <Paper
//               sx={{
//                 ...cardStyle,
//                 // minHeight: 220,
//                 overflow: "hidden",
//               }}
//             >
//               <Typography
//                 fontWeight="bold"
//                 textAlign="center"
//                 sx={{
//                   background: PrimaryColor,
//                   color: "#fff",
//                   py: 1,
//                   mb: 1,
//                   fontSize: "1.6rem",
//                 }}
//               >
//                 {item.title}
//               </Typography>

//               <Box>
//                 <MainSlider stype={item.stype} />
//               </Box>
//             </Paper>
//           </Grid>
//         ))}

//       </Grid>

//       {/* ================= CHART SECTION ================= */}

//       <Grid container spacing={1} mt={0.5}>
//         <Grid item xs={12}>
//           <Paper sx={cardStyle}>
//             <Tab4ContentChart1 />
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* ================= DASHBOARD INVERTER DATA ================= */}

//       <Grid container spacing={1} mt={0.5}>
//         <Grid item xs={12}>
//           <Paper sx={cardStyle}>
//             {/* <DashboardInverterData /> */}
//             <DashboardInverterTab4 />
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* ================= PV PARAMETER ================= */}

//       {/* <Grid container spacing={1} mt={0.5}>
//         <Grid item xs={12}>
//           <Paper sx={cardStyle}>
//             <PvParameter />
//           </Paper>
//         </Grid>
//       </Grid> */}

//       {/* ================= TAB 1 INVERTER ================= */}

//       {/* <Grid container spacing={1} mt={0.5}>
//         <Grid item xs={12}>
//           <Paper sx={cardStyle}>
//             <Tab1Inverter1 />
//           </Paper>
//         </Grid>
//       </Grid> */}

//     </Box>

//     <BottomSlider/>
//     </>

//   );
// };

// export default DashboardTab4;


// 2.


import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Avatar,
} from "@mui/material";



import PersonIcon from "@mui/icons-material/Person";


import DashboardInverterData from "./DashboardInverterData/DashboardInverterData";
import PvParameter from "../../../pv_monitoring/pv_monitoring_tabs/pv_parameter/PvParameter";
import Tab1Inverter1 from "../../../inverter1/tabs/tab1Inverter1/Tab1Inverter1";
import MainSlider from "./MainSlider/MainSlider";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";
import DashboardInverterTab4 from "./DashboardInverterData/DashboardInverterTab4";
import { InstantPowerApi } from "../../../../../../api/Api";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Bar } from "react-chartjs-2";
import Tab4ContentChart1 from "./Tab4ContentChart/TabContentChart1";
import BottomSlider from "./Tab4ContentChart/BottomSlider";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// import MainSlider from "./MainSlider";


const DashboardTab4 = () => {
  const { PrimaryColor } = useContext(AppThemeContext);
  const [time, setTime] = useState(new Date());
  const [logData, setLogData] = useState([]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const [credentials, setCredentials] = useState({
    USER_ID: localStorage.getItem("LoginID"),
    PLANT_code: localStorage.getItem("LCODE"),
    pass_key: localStorage.getItem("PASS_KEY") || "DEFAULT_PASS_KEY",

  });

  const fetchLogData = async () => {
    const res = await InstantPowerApi(credentials);
    if (res?.KW_current && Array.isArray(res.KW_current)) {
      setLogData(res.KW_current);
    } else {
      setLogData([]);
    }
  };


  useEffect(() => {
    // run on mount + when dependency changes
    fetchLogData();

  }, [credentials]);


  const cardStyle = {
    p: 2,
    borderRadius: 3,
    boxShadow: 3,
    height: "100%",
    background: "#fff",
  };

  // 2. card chart

  const chartData = {
    labels: ["Incomer", "Outgoing", "Spare"],
    datasets: [
      {
        label: "Power (KW)",
        data: [
          logData[0]?.Incomer || 0,
          logData[0]?.Outgoing || 0,
          logData[0]?.Spare || 0,
        ],
        backgroundColor: [
          "#1976d2",
          "#2e7d32",
          "#ed6c02",
        ],
        borderWidth: 1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Instantaneous Power [KW]",
      },
    },
  };

  return (

    <>
      <Box p={2} bgcolor="#f5f5f5">

        {/* ================= TOP SECTION ================= */}

        <Grid container spacing={1}>

          {/* POWER CARD */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              <Typography
                fontWeight="bold"
                textAlign="center"
                mb={2}
              >
                Instantaneous Power [KW]
              </Typography>

              {logData.map((log, index) => (
                <Typography
                  variant="h5"
                  color="orange"
                  align="center"
                  mt={4}
                  fontWeight="bold"
                >
                  {log.Incomer} (Incomer)
                </Typography>
              ))}

              {logData.map((log, index) => (
                <Typography
                  variant="h5"
                  color="orange"
                  align="center"
                  mt={4}
                  fontWeight="bold"
                >
                  {log.Outgoing} (Outgoing)
                </Typography>
              ))}

              {logData.map((log, index) => (
                <Typography
                  variant="h5"
                  color="orange"
                  align="center"
                  mt={4}
                  fontWeight="bold"
                >
                  {log.Spare} (Spare)
                </Typography>
              ))}
            </Paper>
          </Grid>

          {/* CHART CARD */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              {/* <Typography
              fontWeight="bold"
              textAlign="center"
              mb={2}
            >
              Live Chart
            </Typography> */}

              <Box >
                <Bar
                  data={chartData}
                  options={chartOptions}
                />
              </Box>
            </Paper>
          </Grid>

          {/* USER DETAIL */}
          {/* <Grid item xs={12} sm={6} md={3}>
          <Paper sx={cardStyle}>
            <Box display="flex" gap={2}>
              <Avatar sx={{ bgcolor: "#1976d2" }}>
                <PersonIcon />
              </Avatar>

              <Box>
                <Typography fontWeight="bold">
                  User Detail
                </Typography>

                <Typography variant="body2">
                  Name: GLOSTER NUVO LIMITED
                </Typography>

                <Typography variant="body2">
                  City: HOWRAH
                </Typography>

                <Typography variant="body2">
                  Total Incomers: 13
                </Typography>

                <Typography variant="body2">
                  Total Energy Meter: 6
                </Typography>

                <Typography
                  variant="body2"
                  color="orange"
                >
                  Commissioned: 29-Aug-2024
                </Typography>
              </Box>
            </Box>
          </Paper>
        </Grid> */}

          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              <Typography
                fontWeight="bold"
                mb={2}
                textAlign="center"
              >
                 Instant Power [KW]
              </Typography>

              <DashboardInverterTab4 />
            </Paper>
          </Grid>

          {/* CLOCK */}
          <Grid item xs={12} sm={6} md={3}>
            <Paper sx={cardStyle}>
              <Typography
                variant="h4"
                align="center"
                fontWeight="bold"
              >
                {time.toLocaleTimeString()}
              </Typography>

              <Typography
                align="center"
                mt={1}
                color="text.secondary"
              >
                {time.toDateString()}
              </Typography>
            </Paper>
          </Grid>

        </Grid>

        {/* ================= MIDDLE SECTION ================= */}

        <Grid container spacing={1} mt={0.5}>

          {[
            { title: "Incomer", stype: "I" },
            { title: "Outgoing", stype: "O" },
            { title: "Spare", stype: "S" },
            { title: "Sensor", stype: "W" },
          ].map((item, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Paper
                sx={{
                  ...cardStyle,
                  // minHeight: 220,
                  overflow: "hidden",
                }}
              >
                <Typography
                  fontWeight="bold"
                  textAlign="center"
                  sx={{
                    background: PrimaryColor,
                    color: "#fff",
                    py: 1,
                    mb: 1,
                    fontSize: "1.6rem",
                  }}
                >
                  {item.title}
                </Typography>

                <Box>
                  <MainSlider stype={item.stype} />
                </Box>
              </Paper>
            </Grid>
          ))}

        </Grid>

        {/* ================= CHART SECTION ================= */}

        <Grid container spacing={1} mt={0.5}>
          <Grid item xs={12}>
            <Paper sx={cardStyle}>
              <Tab4ContentChart1 />
            </Paper>
          </Grid>
        </Grid>

      </Box>

      <BottomSlider />
    </>

  );
};

export default DashboardTab4;